import { Phone, FileText, CalendarClock } from "lucide-react";
import { useCentre } from "@/context/CentreContext";
import { useUI } from "@/context/UIContext";

export default function MobileCTABar() {
  const { current, setSelectorOpen } = useCentre();
  const { openLead } = useUI();
  const tel = current?.phone ? current.phone.replace(/\s/g, "") : null;

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-[95] bg-black border-t border-white/15 grid grid-cols-3 divide-x divide-white/10"
      data-testid="mobile-cta-bar">
      {tel ? (
        <a href={`tel:${tel}`} className="flex flex-col items-center justify-center py-3 gap-0.5 text-hp-yellow" data-testid="mcta-call">
          <Phone size={19} /><span className="text-[11px] font-bold uppercase tracking-wide">Appeler</span>
        </a>
      ) : (
        <button onClick={() => setSelectorOpen(true)} className="flex flex-col items-center justify-center py-3 gap-0.5 text-hp-yellow" data-testid="mcta-call">
          <Phone size={19} /><span className="text-[11px] font-bold uppercase tracking-wide">Appeler</span>
        </button>
      )}
      <button onClick={() => openLead({ request_type: "devis" })} className="flex flex-col items-center justify-center py-3 gap-0.5 text-white" data-testid="mcta-devis">
        <FileText size={19} /><span className="text-[11px] font-bold uppercase tracking-wide">Devis</span>
      </button>
      <button onClick={() => openLead({ request_type: "rdv" })} className="flex flex-col items-center justify-center py-3 gap-0.5 text-white" data-testid="mcta-rdv">
        <CalendarClock size={19} /><span className="text-[11px] font-bold uppercase tracking-wide">RDV</span>
      </button>
    </div>
  );
}
